import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BASIC_IMPORTS } from '@app/shared/shared.imports';

@Component({
  selector: 'app-custom-form-footer',
  templateUrl: './custom-form-footer.component.html',
  styleUrls: ['./custom-form-footer.component.scss'],
  standalone: true,
  imports: [...BASIC_IMPORTS]
})
export class CustomFormFooterComponent {
  @Input() form: FormGroup;
  @Input() isSubmitted: boolean;
  @Input() isClone: boolean;
  @Input() isEdit: boolean;
  @Input() isSaveAddNew: boolean;

  // tslint:disable-next-line:no-output-native
  @Output() submit: EventEmitter<any>;
  @Output() saveAddNew: EventEmitter<any>;
  @Output() cancel: EventEmitter<any>;

  @Input() formValid?: boolean;

  constructor() {
    this.submit = new EventEmitter<any>();
    this.saveAddNew = new EventEmitter<any>();
    this.cancel = new EventEmitter<any>();
  }
  customeValidation() {
    // this.form.
  }
}
